<template>
	<div class="container">
		<el-card>
			<div slot="header">账单管理</div>
			<div style="height: 100%">
				<el-tabs v-model="activeName" type="border-card">
					<el-tab-pane label="电表" name="electric">
						<div>
							<el-form ref="form" :model="form" label-width="80px" size="small" style="">
								<el-form-item label="创建时间" label-width="70px">
									<el-date-picker v-model="queryParams.createStartTime" type="datetime"
										placeholder="选择开始日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
									<label> 到 </label>
									<el-date-picker v-model="queryParams.createEndTime" type="datetime"
										placeholder="选择结束日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="商户名称">
									<el-select v-model="queryParams.lesseeId" placeholder="请选择" clearable filterable
										class="searchTag">
										<el-option v-for="item in lesseeIdOptions" :key="item.key" :label="item.value"
											:value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="电表编号">
									<el-select v-model="queryParams.meterId" placeholder="请选择" clearable filterable
										class="searchTag">
										<el-option v-for="item in meterIdOption" :key="item.key" :label="item.value"
											:value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" @click="handleQuery(true)" size="small"
									style="margin-left: 10px">搜索</el-button>
								<el-button type="primary" style="background-color: #23c6c8 !important"
									@click="exportToExcel" size="small">导出</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="electricTableData" style="width: fit-content" height="94%"
									id="billRecord">
									<el-table-column type="index" width="50" label="序号" align="center"
										:index="indexMethodElectric"></el-table-column>
									<el-table-column prop="billNo" label="账单号" width="160" align="center">
									</el-table-column>
									<el-table-column prop="lesseeId" label="商户名称" width="150" align="center">
									</el-table-column>
									<el-table-column prop="meterId" label="电表编号" width="130" align="center">
									</el-table-column>
									<el-table-column prop="billDate" label="账单所属日期" width="160" align="center">
									</el-table-column>
									<el-table-column prop="startTime" label="开始时间" width="160" align="center">
									</el-table-column>
									<el-table-column prop="endTime" label="结束时间" width="160" align="center">
									</el-table-column>
									<el-table-column prop="startEnergyDegree" label="开始电度数(kW·h)" width="145"
										align="center">
									</el-table-column>
									<el-table-column prop="endEnergyDegree" label="结束电度数(kW·h)" width="145"
										align="center">
									</el-table-column>
									<el-table-column prop="usages" label="用电量(kW·h)" width="115" align="center">
									</el-table-column>
									<el-table-column prop="meterCtRatio" label="ct变比" width="110" align="center">
									</el-table-column>
									<el-table-column prop="price" label="电价格(元)" width="100" align="center">
									</el-table-column>
									<el-table-column prop="fee" label="电费小计(元)" width="120" align="center">
									</el-table-column>
									<el-table-column prop="serviceFeePrice" :label="serviceFeePriceColumnElectric" width="140" align="center">
									</el-table-column>
									<el-table-column prop="serviceFee" :label="serviceFeeColumnElectric" width="140" align="center">
									</el-table-column>
									<el-table-column prop="moneyReceived" label="合计已缴费金额(元)" width="150" align="center">

									</el-table-column>
									<el-table-column prop="balance" label="余额(元)" width="150" align="center">
									</el-table-column>
									<el-table-column prop="type" label="账单类型" width="100" align="center">
									</el-table-column>
								</el-table>
								<div class="block">
									<el-pagination v-show="total > 0" @size-change="handleQuery"
										@current-change="handleQuery" :current-page.sync="queryParams.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]" :page-size.sync="queryParams.size"
										layout="total, sizes, prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="水表" name="water">
						<div>
							<!-- <el-button type="primary">账单详情</el-button> -->

							<el-form ref="form" :model="form" label-width="80px" size="small" style="">
								<el-form-item label="创建时间" label-width="70px">
									<el-date-picker v-model="queryParamsWater.createStartTime" type="datetime"
										placeholder="选择开始日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
									<label> 到 </label>
									<el-date-picker v-model="queryParamsWater.createEndTime" type="datetime"
										placeholder="选择结束日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="商户名称">
									<el-select v-model="queryParamsWater.lesseeId" placeholder="请选择" clearable
										filterable class="searchTag">
										<el-option v-for="item in lesseeIdOptions" :key="item.key" :label="item.value"
											:value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="水表编号">
									<el-select v-model="queryParamsWater.meterId" placeholder="请选择" clearable filterable
										class="searchTag">
										<el-option v-for="item in waterMeterIdOption" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>

								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryWater(true)">
									搜索</el-button>
								<el-button type="primary" size="small" style="background-color: #23c6c8 !important"
									@click="exportToExcelWater">导出</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="waterTableData" style="width: fit-content" height="94%"
									id="billRecordWater">
									<el-table-column type="index" width="50" label="序号" align="center"
										:index="indexMethodWater"></el-table-column>
									<el-table-column prop="billNo" label="账单号" width="160" align="center">
									</el-table-column>
									<el-table-column prop="lesseeId" label="商户名称" width="150" align="center">
									</el-table-column>
									<el-table-column prop="meterId" label="水表编号" width="130" align="center">
									</el-table-column>
									<el-table-column prop="billDate" label="账单所属日期" width="160" align="center">
									</el-table-column>
									<el-table-column prop="startTime" label="开始时间" width="160" align="center">
									</el-table-column>
									<el-table-column prop="endTime" label="结束时间" width="160" align="center">
									</el-table-column>
									<el-table-column prop="startEnergyDegree" label="开始水度数(m³)" width="140"
										align="center">
									</el-table-column>
									<el-table-column prop="endEnergyDegree" label="结束水度数(m³)" width="140"
										align="center">
									</el-table-column>
									<el-table-column prop="usages" label="用水量(m³)" width="110" align="center">
									</el-table-column>
									<el-table-column prop="price" label="水价格(元)" width="100" align="center">
									</el-table-column>

									<el-table-column prop="fee" label="水费小计(元)" width="120" align="center">
									</el-table-column>
									<el-table-column prop="serviceFeePrice" :label="serviceFeePriceColumnWater" width="140" align="center">
									</el-table-column>
									<el-table-column prop="serviceFee" :label="serviceFeeColumnWater" width="140" align="center">
									</el-table-column>

									<el-table-column prop="moneyReceived" label="合计已缴费金额(元)" width="150" align="center">

									</el-table-column>
									<el-table-column prop="balance" label="余额(元)" width="150" align="center">
									</el-table-column>
									<el-table-column prop="type" label="账单类型" width="100" align="center">
									</el-table-column>
								</el-table>
								<div class="block">
									<el-pagination v-show="total1 > 0" @size-change="handleQueryWater"
										@current-change="handleQueryWater" :current-page.sync="queryParamsWater.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]"
										:page-size.sync="queryParamsWater.size"
										layout="total, sizes, prev, pager, next, jumper" :total="total1">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-card>
		<el-dialog :title="electricDialogTitle" :visible.sync="DialogVisible" width="30%">
			<span>密码：</span>
			<el-input v-model="password" placeholder="" type="password"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="DialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="DialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		selectList,
		selectListWater
	} from '../../api/property/billManage';
	import {
		translateObjectEmptyAttributeToNull,
		getCurDayStartTime,
		getCurDayEndTime,
		getCurMonthFirstTime,
		getLastMounth
	} from '../../untils/func';
	import {
		selectLessee,
		selectMeter,
		selectWaterMeter,
	} from '../../api/comboboxLoad';
	import exportTable from '../../untils/exportTable';
	export default {
		data() {
			return {
				form: {},
				DialogVisible: false,
				activeName: 'electric',
				electricDialogTitle: '请输入开闸密码',
				password: '',
				online: '',
				meterIdOption: [],
				waterMeterIdOption: [],
				payWay: '',
				lesseeIdOptions: [],
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: getCurDayStartTime(),
					createEndTime: getCurDayEndTime(),
					lesseeId: '',
					meterId: '',
				},
				queryParamsWater: {
					current: 1,
					size: 100,
					createStartTime: getCurMonthFirstTime(),
					createEndTime: getLastMounth(),
					id: '',
				},
				loading: false,
				total: 0,
				total1: 0,
				electricTableData: [],
				waterTableData: [],
				serviceFeePriceColumnElectric: '',
				serviceFeeColumnElectric: '',
				serviceFeePriceColumnWater: '',
				serviceFeeColumnWater: '',
			};
		},
		created() {
			this.serviceFeePriceColumnElectric = this.$root.serviceFeeNameElectric+"价格(元)";
			this.serviceFeeColumnElectric = this.$root.serviceFeeNameElectric+"小计(元)";
			this.serviceFeePriceColumnWater = this.$root.serviceFeeNameWater+"价格(元)";
			this.serviceFeeColumnWater = this.$root.serviceFeeNameWater+"小计(元)";
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.handleQuery();
				await this.handleQueryWater();
				await this.getSelectLessee();
				await this.getSelectMeter();
				await this.getSelectWaterMeter();
			},
			async handleQuery(isSearchBtn) {
				if (isSearchBtn == true) {
					this.queryParams.current = 1;
				}
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.electricTableData = response.data;
				this.total = response.total;
				this.loading = false;
			},
			async handleQueryWater(isSearchBtn) {
				if (isSearchBtn == true) {
					this.queryParamsWater.current = 1;
				}
				this.loading = true;
				let param = this.queryParamsWater;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectListWater(param).then();
				this.waterTableData = response.data;
				this.total1 = response.total;
				this.loading = false;
			},
			// 导出表格
			async exportToExcel() {
				if (this.electricTableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('billRecord', '电表账单记录');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},
			async exportToExcelWater() {
				if (this.waterTableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParamsWater.size;
					this.queryParamsWater.size = this.total1;
					this.queryParamsWater.current = 1;
					await this.handleQueryWater();
					exportTable.exportExcel('billRecordWater', '水表账单记录');
					this.queryParamsWater.size = size;
					await this.handleQueryWater();
				}
			},
			// 获取商户名称
			async getSelectLessee() {
				const res = await selectLessee().then();
				this.lesseeIdOptions = res.data;
			},
			// 获取电表编号
			async getSelectMeter() {
				const res = await selectMeter().then();
				this.meterIdOption = res.data;
			},
			// 获取水表编号
			async getSelectWaterMeter() {
				const res = await selectWaterMeter().then();
				this.waterMeterIdOption = res.data;
			},
			openGate() {
				this.password = '';
				this.electricDialogTitle = '请输入开闸密码';
				this.DialogVisible = true;
			},
			closeGate() {
				this.password = '';
				this.electricDialogTitle = '请输入关闸密码';
				this.DialogVisible = true;
			},
			openValve() {
				this.password = '';
				this.electricDialogTitle = '请输入开阀密码';
				this.DialogVisible = true;
			},
			closeValve() {
				this.password = '';
				this.electricDialogTitle = '请输入关阀密码';
				this.DialogVisible = true;
			},
			indexMethodElectric(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
			indexMethodWater(index) {
				let num =
					this.queryParamsWater.size * (this.queryParamsWater.current - 1) +
					index +
					1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
		margin-bottom: 10px;
	}

	.searchTag {
		width: 182px;
	}

	/deep/ .el-tabs {
		height: 100% !important;

		.el-tabs__content {
			height: calc(100% - 39px) !important;
		}
	}

	.tableStyle {
		height: calc(100vh - 310px);
	}

	@media screen and (max-width: 1544px) {
		.tableStyle {
			height: calc(100vh - 330px);
		}
	}

	.el-button {
		margin-left: 10px;
	}

	.block {
		margin-top: 10px;
	}
</style>
